export default class Includes {
  constructor(container) {
    this.$ = container;
    this.url = this.$.getAttribute('data-inc');
    this.initialize();
  }

  initialize(){
    fetch(this.url,{
      method: 'GET',
    }).then(response => response.text())
    .then(text => {
      let contents = new DOMParser().parseFromString(text, "text/html");
      contents = contents.querySelector('body').innerHTML;
      if (!this.$.hasChildNodes()) {
        this.$.insertAdjacentHTML('beforeend', contents);
      }
    });
  }

}
